import './Chip.css'

export default function Chip({ active = false, onClick, children, className = '' }) {
  return (
    <button
      type="button"
      className={`ll-chip ${active ? 'll-chip--active' : ''} ${className}`.trim()}
      onClick={onClick}
      aria-pressed={active}
    >
      {children}
    </button>
  )
}
